import { v4 as uuidV4 } from 'uuid';
import type { Clothes } from 'contracts/Clothes';

import bolsa01 from 'assets/images/products/bolsa_01.jpg';
import bolsa02 from 'assets/images/products/bolsa_02.jpg';

import sapato01 from 'assets/images/products/sapato_01.jpg';
import sapato02 from 'assets/images/products/sapato_02.jpg';
import sapato03 from 'assets/images/products/sapato_03.jpg';

export const bags: Clothes[] = [
  {
    id: uuidV4(),
    name: 'Bolsa preta',
    image: bolsa01,
    price: 'R$ 89,91',
    url: 'https://produto.mercadolivre.com.br/MLB-2081040096-bolsa-transversal-feminina-pequena-festa-social-preta-couro-_JM?searchVariation=173894313503#searchVariation=173894313503&position=24&search_layout=grid&type=item&tracking_id=33e11435-296a-4d42-90d9-e96e51b545f5',
  },
  {
    id: uuidV4(),
    name: 'Bolsa com correntaria',
    image: bolsa02,
    price: 'R$ 123,40',
    url: 'https://produto.mercadolivre.com.br/MLB-2061351804-bolsa-feminina-pequena-modelo-baguete-bag-festa-blogueira-_JM?searchVariation=173825115632#searchVariation=173825115632&position=6&search_layout=grid&type=item&tracking_id=cb50a8d6-145d-433a-b0ee-41aa662f95ae',
  },
];

export const shoes: Clothes[] = [
  {
    id: uuidV4(),
    name: 'Bota de zebra',
    image: sapato01,
    price: 'R$ 1.100',
    url: 'https://produto.mercadolivre.com.br/MLB-2640887927-bota-pelo-couro-zebra-cano-longo-cecconello-1870006-5-_JM?searchVariation=174506461960#searchVariation=174506461960&position=1&search_layout=grid&type=item&tracking_id=b2078eab-a412-4ea8-bb29-360ae8955cd9',
  },
  {
    id: uuidV4(),
    name: 'Coturno tratorado',
    image: sapato02,
    price: 'R$ 78,90',
    url: 'https://produto.mercadolivre.com.br/MLB-1975705851-bota-feminina-coturno-tratorado-plataforma-blogueira-moda-_JM?searchVariation=93812900955#searchVariation=93812900955&position=30&search_layout=grid&type=item&tracking_id=5381c41f-5477-4c18-b32b-f796a4458c20',
  },
  {
    id: uuidV4(),
    name: 'Bota com plataforma',
    image: sapato03,
    price: 'R$ 299,90',
    url: 'https://produto.mercadolivre.com.br/MLB-2194709783-bota-dakota-g4951-_JM?attributes=COLOR_SECONDARY_COLOR%3AUmloYW5uYSBIb2xseXdvb2Q%3D&quantity=1',
  },
];
